export default __webpack_public_path__ + "static/media/webilo-marketing.f99db80b.svg";